import { InputElement, InputOptional, InputType } from "./model/Element";
import { Page } from "./model/Page"

import { flow as flowIC, setLang as setLangIC, getLang as getLangIC } from "./flows/FlowDefinitionICEngine"
import { flow as flowFLEPA, setLang as setLangFLEPA, getLang as getLangFLEPA } from "./flows/FlowDefinitionFLE-PA"
import { flow as flow3, setLang as setLang3, getLang as getLang3 } from "./flows/FlowDefinitionMMC"
import { flow as flow4, setLang as setLang4, getLang as getLang4 } from "./flows/FlowDefinitionServoAllgemein"


export interface Flow {
    name: string;
    label: string;
    Pages: Page[];
}

var flow: Flow;
var setLang: (lang: string) => void;
var getLang: () => string;

// defaults:
setLang = setLangIC;
getLang = getLangIC;


// import dynamically
/*
var flow: Flow;
var setLang: (lang: string) => void;
var getLang: () => string;
export async function loadFlowDefinition(fname: string) {
    //import("./flows/FlowDefinitionICEngine").then((f) => {    // is like "import * as a from "./flows/FlowDefinitionFLE-PA"
    import("./flows/" + fname).then((f) => {    // is like "import * as a from "./flows/FlowDefinitionFLE-PA"
        flow = f.flow;
        setLang = f.setLang;
        getLang = f.getLang;

        console.log("Loaded flow definition " + fname);
    })
    .catch((err) => {
        console.log("Failed to load flow definition", err);
    });
    console.log("Weiter");
}
*/

// initialize:
export function setFlowTarget(target: string | null | undefined) {
    if((target === null) || (target === undefined))
        return "";

    if(target === flowIC.name) {
        flow = flowIC;
        setLang = setLangIC;
        getLang = getLangIC;
    }
    else if(target === flowFLEPA.name) {
        flow = flowFLEPA;
        setLang = setLangFLEPA;
        getLang = getLangFLEPA;
    }
    else if(target === flow3.name) {
        flow = flow3;
        setLang = setLang3;
        getLang = getLang3;
    }
    else if(target === flow4.name) {
        flow = flow4;
        setLang = setLang4;
        getLang = getLang4;
    }
    //else if(target === "2") {
    //    flow = flow2;
    //    setLang = setLang2;
    //    getLang = getLang2;
    //}

    //if(initLang != undefined)
    //    initLang(getLang());
}
//setFlowTarget("1");   -#-

export function getFlowTarget() {
    return flow.name;
}


// ------------------------------------------------------------------------------------------------
// Methods to handle language
export function setLanguage(code: string) {
    setLang(code);
}

export function getLanguage(): string {
    return getLang();
}


// ------------------------------------------------------------------------------------------------
// Methods to access flow compoenents and elements
export function getFlow() {
    return flow;
}

// ---
export function testPageValidByName(pagename: string): boolean {
    let page: Page | undefined = getPageByName(pagename);
    if(page === undefined)
        return true;

    let validity = testPageMandatoryByName(page.name);   // all mandatory fields filled ?
    if(validity.res === false)
        return false;  // Mandatory inputs are missing

    // if all mandatory fields are filled, test for page-specific validations by calling the isValid-function of page (if available)
    if(page.isValid !== undefined) {
        if(page.isValid().res === false) {
            return false;
        }
    }
          
    return true;
}


// ---
export function testPageMandatoryByKey(pagekey: string): boolean {
    let page: Page | undefined = getPageByKey(pagekey);

    if(page === undefined)
        return true;

    let ret: boolean = false;
    for(let i=0; i<page.elements.length; i++) {
        let el: InputElement = page.elements[i];
        if(el.isMandatory === true) {
            if((el.value !== undefined) && (el.value === "") ) {
                ret = false;
            }
        }
    }

    return ret;
}

export function testPageMandatoryByName(pagename: string): { res: boolean, elname: string } {
    let page: Page | undefined = getPageByName(pagename);

    if(page === undefined)
        return { res: true, elname: "" };

    let res: boolean = true;
    let elname: string = "";
    for(let i=0; i<page.elements.length; i++) {
        let el: InputElement = page.elements[i];
        if(el.isMandatory === true) {   // is element mandatory ?
            res = true;
            elname = el.label;

            // test if value is filled
            if(el.value === undefined) {
                res =  false;
            }
            else {
                if(el.value === "")
                    res = false;
                else
                    res = true;
            }

            // value is o.k. up to now, so test if visible: if not, set res = true (invisible means, isMandatory does not care), otherwise res remains its value
            if(el.isVisible !== undefined) {
                if(el.isVisible() === false) {
                    res = true;
                }
            }

            // value is filled and visible: test if valid: if not set res = false, otherwise res remains it's value
            if(el.isValid !== undefined) {
                if(el.isValid() === false) {
                    res = false;
                }
            }

            // this element is not valid, so we leave the loop
            if(res === false)
                break;
        }
    }
    
    return { res: res, elname: elname };
}


// ---
export function getPageByIndex(pagenumber: number): Page | undefined {
    return getFlow().Pages[pagenumber];    
}


export function getPageByKey(pagekey: string): Page | undefined {
    return getFlow().Pages.find(( { id } ) => id === pagekey);
}

export function getPageByName(pagename: string): Page | undefined {
    return getFlow().Pages.find(( { name } ) => name === pagename);
}
// ---
export function getElementWithPagename(pagename: string, elementname: string): InputElement | undefined {
    let page: Page | undefined = getPageByName(pagename);   // retrieve the page by its name-attribute !!!
    if(page === undefined)
        return undefined;

    let result: InputElement | undefined = undefined;
    for(let i=0; i<page.elements.length; i++) {
        if(page.elements[i].name === elementname)
            result = page.elements[i];
    }

    return result;
}

export function getElementWithPagekey(pagekey: string, elementname: string): InputElement | undefined {
    let page: Page | undefined = getPageByKey(pagekey);   // retrieve the page by its name-attribute !!!
    if(page === undefined)
        return undefined;

    let result: InputElement | undefined = undefined;
    for(let i=0; i<page.elements.length; i++) {
        if(page.elements[i].name === elementname)
            result = page.elements[i];
    }

    return result;
}


export function synchronizeElements(pagekeySource: string, elementnameSource: string, pagekeyTarget: string, elementnameTarget: string) {
    let elSource: InputElement | undefined = getElementWithPagekey(pagekeySource, elementnameSource);
    let elTarget: InputElement | undefined = getElementWithPagekey(pagekeyTarget, pagekeyTarget);

    if((elTarget === undefined) || (elSource === undefined)) return;

    // transfer value:
    elTarget.value = elSource.value;

    if(((elTarget.type === InputType.Optional) || (elTarget.type === InputType.Multiple))
      && ((elSource.type === InputType.Optional) || (elSource.type === InputType.Multiple))
    ) {
        (elTarget as InputOptional).options = (elSource as InputOptional).options;
    }

}



/*
export function refValue(pagekey: string, elementname: string): string | number | boolean | string[] | undefined {
    let page: Page | undefined = getPageByKey(pagekey);   // retrieve the page by its name-attribute !!!
    if(page === undefined)
        return undefined;

    let result: InputElement | undefined = undefined;
    for(let i=0; i<page.elements.length; i++) {
        if(page.elements[i].name === elementname)
            result = page.elements[i];
    }

    if(result === undefined)
        return undefined;
    else
        return result.value;
}

export function refOptions(pagekey: string, elementname: string): string[] {
    let page: Page | undefined = getPageByKey(pagekey);   // retrieve the page by its name-attribute !!!
    if(page === undefined)
        return [];

    let result: InputElement | undefined = undefined;
    for(let i=0; i<page.elements.length; i++) {
        if((page.elements[i].name === elementname) && ((page.elements[i].type === InputType.Optional) || (page.elements[i].type === InputType.Multiple)))
            result = page.elements[i];
    }

    if(result === undefined)
        return [];
    else
        return (result as InputOptional).options;
}
*/

// ------------------------------------------------------------------------------------------------
// Helper methods acting on flow datastructure like create a mail based on flow or pdf.
export function createMailLink(strAdressTo: string, strSubject: string) {
    //let strBody: string = "Sehr geehrte Damen und Herren,\nschicken Sie bitte eine Berechnung zu folgenden Motordaten:\n\n";
    let strBody: string = "Dear Sir or madam,\n\nplease send me a computation for this layout data:\n\n";

    // always print first page:
    let pageToDisplay: Page | undefined = getPageByIndex(0);
    strBody += printSinglePage(pageToDisplay);

    while(pageToDisplay !== undefined) {
        strBody += '\n';
        let nextpagekey: string = pageToDisplay.nextResolver();
        let nextPageToDisplay: Page | undefined = getPageByKey(nextpagekey);

        if(nextPageToDisplay === undefined || nextPageToDisplay.name === pageToDisplay.name)
            break;

        pageToDisplay = nextPageToDisplay;
        strBody += printSinglePage(pageToDisplay);
    }

    var strMailLink = "mailto:" + strAdressTo + "?subject=" + encodeURIComponent(strSubject) + "&body=" + encodeURIComponent(strBody);
    //var strMailLink = "mailto:" + strAdressTo + "?subject=" + encodeURIComponent(strSubject) + "&body=" + strBody;
    return strMailLink;
}



export function getNextPageKey(p: Page | undefined): string {
    if(p === undefined) {
        return "page1";
    }

    let nextpage: string = p.nextResolver();
    return nextpage
}


export function getPrevPageKey(p: Page | undefined): string {
    if(p === undefined) {
        return "page1";
    }

    // cycle with nextResolver from page1 on until we reach the current page: return the page before
    //let pagerunner: Page | undefined = getPageByIndex(0);   // initially first page
    //if(pagerunner === undefined) return "page1";

    let currentKey: string = p.id as string; //getKeyForName(p.name);
    let runningKey: string = "page1";
    let previousKey: string = "page1";
    while(currentKey !== runningKey) {
        previousKey = runningKey;

        // retrieve net page
        let runningPage: Page | undefined = getPageByKey(runningKey);
        if(runningPage === undefined)  return "page1";
        runningKey = runningPage.nextResolver();
    }

    return previousKey;
}


function printSinglePage(p: Page | undefined): string {
    let pageString: string = "";
    if(p === undefined)
        return "";

    pageString += (p.name + "\n");    

    //
    for(let i=0; i<p.elements.length; i++) {
        let e: InputElement | undefined = p.elements[i];

        if((e.type === InputType.Action) || (e.type === InputType.PageForward)  || (e.type === InputType.Image))  // we omit elements with no input value
            continue;

        //if((e instanceof InputAction) || (e instanceof InputPageForward))  // we omit elements with no input value
        //    continue;

        pageString += (e.name + ": " + e.value + "\n");    
    }

    return pageString;
}
